import axios from 'axios';
import { get, set, remove } from 'js-cookie';
import { merge } from 'lodash';
import { jwtDecode } from 'jwt-decode';
import { getData } from './apiCall';
const APPLICANT_COOKIS = 'applicant_cookie';
const VENDOR_COOKIS = 'vendor_cookie';

/**
 * Check the currently logged in user's authentication status
 */
export const checkAuth = (): any => async (dispatch) => {
  const response = await axios.get(`${process.env.API_URL}/authentication`);
  if (response.data.code !== 200) {
    dispatch({ type: 'APP_UNAUTHENTICATED' });
    return false;
  }
  localStorage.setItem(
    'resources',
    JSON.stringify(response.data.data.userAccess)
  );
  dispatch({
    type: 'APP_AUTHENTICATED',
    user: response.data.data.userRes,
    access: response.data.data.userAccess,
  });
  return response.data.data;
};

/**
 * Check the currently logged in user's global administrative rights
 */
export const checkGlobalAdmin = (): any => async (dispatch) => {
  const response = await axios.get(
    `${process.env.API_URL}/v1/authentication/admin`
  );
  if (response.data.errors) {
    dispatch({ type: 'APP_DISABLE_ADMIN' });
    return false;
  }
  dispatch({ type: 'APP_ENABLE_ADMIN' });
  return true;
};

/**
 * Set the authorization headers
 */
export const setAuthHeader =
  (jwt: string): any =>
    async () => {
      axios.defaults.headers.common.authorization = `Bearer ${jwt}`;
      axios.defaults.headers.common.token = jwt;
      axios.defaults.headers.common.timezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
    };

/**
 * Set the authentication session JWT token & Role of user/Admin
 */
export const setJWT =
  (jwt: string): any =>
    async (dispatch) => {
      let payload = { jwt };
      const { designation }: any = jwtDecode(jwt);
      if (designation == 'Admin') {
        dispatch({ type: 'APP_ENABLE_ADMIN' });
      } else {
        dispatch({ type: 'APP_DISABLE_ADMIN' });
      }
      const token = get(process.env.APP_COOKIE);
      const localData = token ? JSON.parse(get(process.env.APP_COOKIE)) : null;

      if (localData) {
        payload = merge(localData, payload);
      }
      set(process.env.APP_COOKIE, JSON.stringify(payload));
    };

/**
 * Get the authentication session JWT token
 */
export const getJWT = (): any => async (dispatch) => {
  const token = get(process.env.APP_COOKIE);
  const localData = token ? JSON.parse(token) : null;
  if (localData) {
    const { designation }: any = jwtDecode(localData.jwt);
    if (designation == 'Admin') {
      dispatch({ type: 'APP_ENABLE_ADMIN' });
    } else {
      dispatch({ type: 'APP_DISABLE_ADMIN' });
    }
    return localData.jwt;
  }
  return undefined;
};

/**
 * Get the authentication session Designation
 */
export const getRole = (): any => async () => {
  const token = get(process.env.APP_COOKIE);
  const localData = token ? JSON.parse(get(process.env.APP_COOKIE)) : null;
  if (localData) {
    return localData.role;
  }
  return undefined;
};

/**
 * Clear the authentication session JWT token
 */
export const clearJWT = (): any => async () => {
  remove(process.env.APP_COOKIE);
};

/**
 * Register a new user
 */
export const register =
  (
    email: string,
    password: string,
    segment_id: number,
    role: string,
    Expiry: string
  ): any =>
    async (dispatch) => {
      // console.log('newww dataaaaaaaa:email',email,'passsss',password,'segment',segment_id,'expiry',Expiry)
      const x = await dispatch(getJWT());
      const response = await axios.post(
        `${process.env.API_URL}/v1/authentication/register`,
        {
          email,
          password,
          segment_id,
          role,
          Expiry,
          x,
        }
      );
      console.log(' data of auth function register reasponce', response);
      return response.data;
    };

/**
 * Login an existing user
 */
export const loginUser =
  (data, callback): any =>
    async (dispatch) => {
      const response = await axios.post(
        `${process.env.API_URL}/authentication/login`,
        data
      );
      if (response.data.code === 200) {
        try {
          await dispatch(setJWT(response.data.data.accessToken));
          await dispatch(setAuthHeader(response.data.data.accessToken));
          await dispatch(checkAuth());
          callback(response.data);
        } catch (error) {
          console.log("errorerrorerrorerror/ ", error)
          callback(response.data);
        }
      } else {
        callback(response.data);
      }
    };

/**
 * Logout a currently logged in user
 */
export const logout =
  (callback: any): any =>
    async (dispatch) => {
      if (window.confirm('Are you sure want to logout?')) {
        // const response = await axios.post(`${process.env.API_URL}/v1//authentication/logout`);
        // if (!response.data.errors) {
        await dispatch(clearJWT());
        localStorage.clear();
        // await dispatch(checkAuth());
        callback();
        // }
        // return response.data;
      }
    };

export const logoutUnAuthenticat =
  (callback: any): any => {
    remove(process.env.APP_COOKIE);
    localStorage.clear();
    // async (dispatch) => {
    //   await dispatch(clearJWT());
    //   await dispatch(checkAuth());
    callback();
    // }
  };

export const segmentList = (): any => async () => {
  console.log('return data of auth function11111', 'eeeeeeee');
  const response = await axios.get(`${process.env.API_URL}/v1/seg`);
  console.log('segment list ', response.data.data);
  if (!response.data.errors) {
  }

  return response.data.data;
};

// sub broker list

export const subBrokerList = (): any => async () => {
  //  console.log('return data of auth function11111','eeeeeeee');
  const response = await axios.get(`${process.env.API_URL}/v1/brokerType`);
  if (!response.data.errors) {
  }

  return response.data.data;
};

const sort = (a, b) => {
  return a.order - b.order;
}

// system user list
export const getAccess = (): any => async (dispatch) => {
  const response = await axios.get(`${process.env.API_URL}/routing`, {
    params: { pageSize: 2000, current: 1 },
  });
  if (response.data.data && response.data.data.length > 0) {
    dispatch({ type: 'APP_NAVIGATIONS', navigations: response.data.data });
  } else {
    dispatch({ type: 'APP_NAVIGATIONS', navigations: [] });
  }
  return response.data.data;
};

export const getTabs = (): any => async (dispatch) => {
  const response = await axios.get(`${process.env.API_URL}/routing/tabs/list`, { params: {} });
  if (response.data.data && response.data.data.length > 0) {
    dispatch({ type: 'APP_TABS', tabs: response.data.data });
  } else {
    dispatch({ type: 'APP_TABS', tabs: [] });
  }
  return response.data.data;
};

// system user list

export const systemUserList = (): any => async () => {
  const response = await axios.get(`${process.env.API_URL}/v1/users/list`);
  return response.data.data.rows;
};

// change password

export const changepass =
  (oldPassword: string, newPassword: string): any =>
    async () => {
      const response = await axios.post(
        `${process.env.API_URL}/v1/users/changePassword`,
        {
          oldPassword,
          newPassword,
        }
      );
      return response;
    };


export const forgotPassword = (data): any =>
  async () => {
    try {
      const response = await axios.post(`${process.env.API_URL}/authentication/forgot/password/with/passcode`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };


export const getIPAddress = async () => {
  const response = await fetch('https://api.ipify.org?format=json');
  const data = await response.json();
  return data.ip;
}

export const getLocation = (): Promise<{ latitude: number; longitude: number }> => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => reject(error)
      );
    } else {
      reject(new Error('Geolocation is not supported by this browser.'));
    }
  });
}

// Function to get Browser Details
export const getBrowserDetails = () => {
  const userAgent = navigator.userAgent;
  return {
    platform: /Mobi|Android|iPhone/i.test(userAgent) ? 'mobile' : 'web',
    userAgent,
  };
}

export const setVendorJWT = (jwt) => {
  let payload = { jwt };
  const localData = get(VENDOR_COOKIS);
  if (localData) {
    payload = merge(JSON.parse(localData), payload);
  }
  set(VENDOR_COOKIS, JSON.stringify(payload));
};


export const setApplicantJWT = (jwt) => {
  let payload = { jwt };
  const localData = get(APPLICANT_COOKIS);
  if (localData) {
    payload = merge(JSON.parse(localData), payload);
  }
  set(APPLICANT_COOKIS, JSON.stringify(payload));
};

export const setApplicantCookies = (data) => {
  setApplicantJWT(data.accessToken);
  setAuthHeader(data.accessToken)
}

export const setVendorCookies = (data) => {
  setVendorJWT(data.accessToken);
  setAuthHeader(data.accessToken)
}

export const getApplicantData = (): any => async (dispatch) => {
  const localData = get(APPLICANT_COOKIS)
  if (localData) {
    const token = JSON.parse(localData).jwt;
    await dispatch(setAuthHeader(token));
    const response = await axios.get(`${process.env.API_URL}/authentication/applicant`);
    if (response.data.code !== 200) {
      clearVendorJWT();
      return false
    } else {
      return response.data.data;
    }
  } else {
    return false
  }
};

export const getVendorData = (): any => async (dispatch) => {
  const localData = get(VENDOR_COOKIS)
  if (localData) {
    const token = JSON.parse(localData).jwt;
    await dispatch(setAuthHeader(token));
    const response = await axios.get(`${process.env.API_URL}/authentication/vendorauth`);
    if (response.data.code !== 200) {
      clearVendorJWT();
      return false
    } else {
      return response.data.data;
    }
  } else {
    return false
  }
};

export const clearApplicantJWT = async () => {
  remove(APPLICANT_COOKIS);
  location.href = '/login/candidate'
};

export const clearVendorJWT = async () => {
  remove(VENDOR_COOKIS);
  location.href = '/vendor-login'
};

interface FetchWithCacheArgs {
  key: string;
  url: string;
  query?: Record<string, any>;
  cacheDuration?: number;
  reloadData?: Boolean;
}

export const fetchWithCache = ({
  key,
  url,
  query = {},
  cacheDuration = 5 * 60 * 1000,
  reloadData = false
}: FetchWithCacheArgs): any => {
  return async (dispatch, getState) => {
    const cache = getState().app.cache?.[key];
    const now = Date.now();

    const isCacheValid = !reloadData && cache?.lastFetched && now - cache.lastFetched < cacheDuration;
    if (isCacheValid) return;

    dispatch({ type: 'API_REQUEST', payload: { key } });

    try {
      const res = await dispatch(getData(url, query)); // assuming getData is also a thunk
      const data = res.data;

      dispatch({
        type: 'API_SUCCESS',
        payload: { key, data },
      });
    } catch (err: any) {
      dispatch({
        type: 'API_FAILURE',
        payload: { key, error: err.message },
      });
    }
  };
};
